import { AnchorPointPopupInfo } from '../../../../../mapComponents/Popups';
import CustomerMergeIndicator from '../../../../../common/CustomerMergeIndicator';

const AnchorPointPopup = ({
  anchorPointInfo,
  theme,
  showNotification,
  refreshData,
  scenarioID
}) => {
  return (
    <AnchorPointPopupInfo
      data={{
        anchorPointName: (
          <>
            {anchorPointInfo.displayCustomerName}
            <CustomerMergeIndicator displayCustomerName={anchorPointInfo.displayCustomerName} customerName={anchorPointInfo.consigneeName} />
          </>
        ),
        ...anchorPointInfo
      }}
      theme={theme}
      scenarioID={scenarioID}
      showNotification={showNotification}
      refreshData={refreshData}
      markerColor={theme.AnchorBGColor}
      markerBorderColor={theme.routeMapColorPalette.MarkerBorderColor}
      markerStrokeColor={theme.AnchorTextColor}
    />
  );
};

export default AnchorPointPopup;
